module.exports = __webpack_public_path__ + "img/sun.58c341f0.svg";